<template>
  <section class="solutions" id="solutions">
    <div class="container">
      <div class="section-header">
        <div class="section-badge">我们的业务</div>
        <h2 class="section-title">全方位的<span class="highlight">数字解决方案</span></h2>
        <p class="section-description">
          我们提供从产品设计到技术实现的全栈服务，帮助企业构建完整的数字化生态系统，
          实现业务增长和用户体验的双重提升。
        </p>
      </div>
      
      <div class="solutions-grid">
        <div class="solution-card" v-for="solution in solutions" :key="solution.id">
          <div class="card-header" :style="{ background: solution.headerColor }">
            <div class="card-icon">{{ solution.icon }}</div>
            <h3 class="card-title">{{ solution.title }}</h3>
          </div>
          <div class="card-body">
            <p class="card-description">{{ solution.description }}</p>
            <ul class="card-features">
              <li v-for="feature in solution.features" :key="feature">
                <span class="check-icon">✓</span>
                {{ feature }}
              </li>
            </ul>
            <a href="#" class="card-link">
              了解更多 →
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SolutionsSection',
  data() {
    return {
      solutions: [
        {
          id: 1,
          icon: '💻',
          title: '产品设计与开发',
          description: '我们提供从用户研究、交互设计到前端开发、后端开发的全流程产品开发服务，打造用户喜爱的数字产品。',
          headerColor: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
          features: [
            '用户体验设计(UX/UI)',
            'Web应用开发',
            '移动应用开发',
            '产品迭代与优化'
          ]
        },
        {
          id: 2,
          icon: '📈',
          title: '数字化转型咨询',
          description: '帮助企业制定数字化战略，优化业务流程，实现组织转型，提升运营效率和市场竞争力。',
          headerColor: 'linear-gradient(135deg, #8b5cf6, #a78bfa)',
          features: [
            '数字化战略规划',
            '业务流程优化',
            '组织变革管理',
            '数字化能力建设'
          ]
        },
        {
          id: 3,
          icon: '🤖',
          title: '数据与人工智能',
          description: '利用大数据分析和人工智能技术，帮助企业挖掘数据价值，实现智能化决策和个性化服务。',
          headerColor: 'linear-gradient(135deg, #f59e0b, #fbbf24)',
          features: [
            '数据平台搭建',
            '数据分析与可视化',
            'AI模型开发与部署',
            '智能推荐系统'
          ]
        },
        // {
        //   id: 4,
        //   icon: '☁️',
        //   title: '云计算与DevOps',
        //   description: '提供云基础设施建设、迁移和运维服务，实现自动化部署和持续集成，提升开发效率和系统稳定性。',
        //   headerColor: 'linear-gradient(135deg, #10b981, #34d399)',
        //   features: [
        //     '云架构设计与实施',
        //     '容器化与Kubernetes',
        //     'CI/CD流程构建',
        //     '监控与运维自动化'
        //   ]
        // },
        // {
        //   id: 5,
        //   icon: '🏷️',
        //   title: '品牌设计与营销',
        //   description: '打造独特的品牌形象，制定有效的数字营销策略，提升品牌知名度和用户转化率。',
        //   headerColor: 'linear-gradient(135deg, #ef4444, #f87171)',
        //   features: [
        //     '品牌标识设计',
        //     '视觉识别系统(VIS)',
        //     '数字营销策划',
        //     '内容创作与传播'
        //   ]
        // },
        // {
        //   id: 6,
        //   icon: '⭐',
        //   title: '信息安全与合规',
        //   description: '保障企业信息系统安全，满足行业合规要求，防范网络威胁，保护用户数据隐私。',
        //   headerColor: 'linear-gradient(135deg, #7c3aed, #a78bfa)',
        //   features: [
        //     '安全评估与测试',
        //     '安全架构设计',
        //     '数据隐私保护',
        //     '合规咨询与实施'
        //   ]
        // }
      ]
    }
  }
}
</script>

<style scoped>
.solutions {
  padding: 100px 0;
  background: #f8fafc;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.section-header {
  text-align: center;
  margin-bottom: 80px;
}

.section-badge {
  display: inline-block;
  background: #3C59FF;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 24px;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 24px 0;
}

.highlight {
  color: #3C59FF;
}

.section-description {
  font-size: 1.125rem;
  line-height: 1.7;
  color: #6b7280;
  margin: 0;
  max-width: 800px;
  margin: 0 auto;
}

.solutions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 32px;
}

.solution-card {
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  background: white;
}

.solution-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.card-header {
  padding: 32px 32px 24px 32px;
  border-radius: 20px 20px 0 0;
  position: relative;
}

.card-icon {
  width: 60px;
  height: 60px;
  background: white;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #8b5cf6;
  margin-bottom: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 32px;
  background: white;
  border-radius: 0 0 20px 20px;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
  margin: 0;
  text-align: left;
}

.card-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #374151;
  margin: 0 0 24px 0;
  text-align: left;
}

.card-features {
  list-style: none;
  padding: 0;
  margin: 0 0 24px 0;
}

.card-features li {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  font-size: 0.875rem;
  color: #374151;
  text-align: left;
}

.check-icon {
  width: 20px;
  height: 20px;
  background: #00EDB2;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.card-link {
  display: inline-flex;
  align-items: center;
  color: #8b5cf6;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.card-link:hover {
  color: #7c3aed;
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .solutions {
    padding: 60px 0;
  }
  
  .container {
    padding: 0 16px;
  }
  
  .section-title {
    font-size: 1.75rem;
    line-height: 1.3;
  }
  
  .section-description {
    font-size: 1rem;
    margin-bottom: 40px;
  }
  
  .solutions-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .solution-card {
    margin-bottom: 0;
  }
  
  .card-header {
    padding: 24px 20px 16px 20px;
  }
  
  .card-body {
    padding: 20px;
  }
  
  .card-title {
    font-size: 1.25rem;
  }
  
  .card-description {
    font-size: 0.9rem;
  }
  
  .card-features {
    gap: 8px;
  }
  
  .card-features li {
    font-size: 0.85rem;
  }
}
</style>
